import React, { useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
// import { useNavigate } from "react-router-dom";

import { Alert, Snackbar } from "@mui/material";
import UtilsFormule from "../utils/UtilsFormule";
import UtilsUrl from "../utils/UtilsUrl";
import uploadAndDownloadService from "../services/uploadAndDownloadFile";
import FileService from "../services/FileService";
import getCurrentUserId from "../reduxSaga/sagas/requests/currentUserId";

const DataTableTransactionEndRecieve = ({ refFacture, listProduits }) => {
  //   const navigate = useNavigate();

  const [products, setProducts] = useState(listProduits);
  // const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [pathFile, setPathFile] = useState(null);

  const { SearchBar } = Search;

  function nameFormatter(cell, row) {
    return (
      <span>
        {row.userCreator.firstName} {row.userCreator.lastName}
      </span>
    );
  }
  function nameFormatter(cell, row) {
    return (
      <span>
        {row.userCreator.firstName} {row.userCreator.lastName}
      </span>
    );
  }
  function warehouseFormatter(cell, row) {
    if (cell === "Garbage WARHOUSE") {
      return <span>Dépôt des retours (Système)</span>;
    } else {
      return <span>{cell}</span>;
    }
  }
  function dateFormatter(cell, row) {
    return <span>{UtilsFormule.formatDateHours(cell)}</span>;
  }

  const columns = [
    {
      dataField: "warehouseName",
      text: "Dépôt",
      headerAlign: "center",
      formatter: warehouseFormatter,
    },
    {
      dataField: "creationDate",
      text: "Date livraison",
      align: "center",
      formatter: dateFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "name",
      text: "Responsable",
      align: "center",
      formatter: nameFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "name",
      text: "BL",
      align: "center",
      formatter: nameFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "uniqueId",
      text: "BR",
      headerAlign: "center",
      align: "center",
      formatter: buttonFormatter,
      headerStyle: () => {
        return { width: "10%" };
      },
    },
  ];
  const onShowFileInOtherWindowHandler = (path) => {
    uploadAndDownloadService
      .downloadFile(path)
      .then((response) => {
        //Build a URL from the file
        if (response.headers["content-type"] === "image/png") {
          const file = new Blob([response.data], { type: "image/png" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "application/pdf") {
          const file = new Blob([response.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpeg") {
          const file = new Blob([response.data], { type: "image/jpeg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpg") {
          const file = new Blob([response.data], { type: "image/jpg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
  const onUploadFileHandler = (refOperation) => {
    console.log("onUploadFileHandler",refOperation)
    FileService.generateBonReception(
      getCurrentUserId(),
      refFacture,
      refOperation
    ).then((response) => {
      if (response.data["success"]) {
        console.log("response",response)
        setPathFile(response.data["success"]);
        onShowFileInOtherWindowHandler(
          UtilsUrl.fileRetailURL() + response.data["success"]
        );
      }
    }).catch((error)=>{
      console.log("error",error)

    })
  };
  function buttonFormatter(cell, row) {
    console.log("buttonFormatter row",row.path)
    if (row.path !== null) {
      return (
        <span>
          <button
            // style={{ width: 40 }}
            class="btn bg-gray btn-sm "
            onClick={() =>
              onShowFileInOtherWindowHandler(
                UtilsUrl.fileRetailURL() + row.path
              )
            }
          >
            <i class="fas fa-eye"></i>
          </button>
        </span>
      );
    } else  if (row.path === null) {
      console.log("buttonFormatter row",row.path)

      return (
        <span>
          <button
            // style={{ width: 40 }}
            class="btn bg-gray btn-sm "
            onClick={() => onUploadFileHandler(row.uniqueId)}
          >
            <i class="fas fa-plus"></i>
          </button>
        </span>
      );
    }
  }

  const rates = (row) => {
    if (row.productPurchaseHistories.length !== 0) {
      console.log("productPurchaseHistories", row.productPurchaseHistories);
      return (
        <div class="col-md-12">
          <div class="card card-dark collapsed-card">
            <div class="card-header">
              <h3 class="card-title">Les opérations de réception</h3>
              <div class="card-tools">
                <button
                  type="button"
                  class="btn btn-tool"
                  data-card-widget="collapse"
                >
                  <i class="fas fa-plus"></i>
                </button>
              </div>
            </div>

            <div class="card-body">
              {listRates(row.productPurchaseHistories)}
            </div>
          </div>
        </div>
      );
    }
  };
  const listRates = (list) => {
    return (
      <table
        class="table table-striped table-bordered table-sm"
        cellspacing="0"
        width="100%"
      >
        <thead>
          <tr className="text-center">
            <th>Libellé</th>
            <th style={{ width: "15%" }}>Opération</th>
            <th style={{ width: "15%" }}>Note</th>
            <th style={{ width: "15%" }}>DC</th>
            <th style={{ width: "15%" }}>Responsable</th>
            <th style={{ width: "8%" }}>Q.R</th>
            <th style={{ width: "8%" }}>Q.T</th>
          </tr>
        </thead>
        <tbody>
          {list &&
            list.map((element, i) => (
              <tr key={i}>
                <td>{element.productPurchase.product.name}</td>

                <td className="text-center">{typeFormatter(element.type)} </td>
                <td>{element.note}</td>

                <td>{UtilsFormule.formatDateHours(element.creationDate)} </td>
                <td>
                  <span>
                    {element.creator.firstName} {element.creator.lastName}
                  </span>
                </td>

                <td className="text-center">{element.quantity} </td>

                <td className="text-center">
                  {element.productPurchase.quantity}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    );
  };
  function typeFormatter(type) {
    if (type === 1) {
      return <span className="badge bg-success">Nouvel arrivage</span>;
    } else if (type === 2) {
      return <span className="badge bg-warning">Refusé</span>;
    } else if (type === 3) {
      return <span className="badge bg-primary">Arrivage du retours</span>;
    }
  }

  const importProduct = (row) => {
    return (
      <div className="row">
        {" "}
        <div class="col-md-12">
          <p>Référence : {row.uniqueId}</p>
        </div>
        {rates(row)}
      </div>
    );
  };
  const expandRow = {
    renderer: (row) => importProduct(row),
    showExpandColumn: true,
    expandByColumnOnly: true,
    expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      if (isAnyExpands) {
        return <b>-</b>;
      }
      return <b>+</b>;
    },
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <b>-</b>;
      }
      return <b>+</b>;
    },
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };

  return (
    <div>
      <ToolkitProvider
        keyField="uniqueId"
        data={products}
        columns={columns}
        //   onTableChange={handleTableChange}
        exportCSV
        search
      >
        {(props) => (
          <div>
            <div className="row ml-0">
              <div>
                <SearchBar
                  {...props.searchProps}
                  className="custome-search-field"
                  style={{ color: "black" }}
                  placeholder="Chercher"
                ></SearchBar>
              </div>
            </div>
            <div className="row">
              <BootstrapTable
                {...props.baseProps}
                pagination={paginationFactory(options)}
                striped
                hover
                condensed
                expandRow={expandRow}
              />
            </div>
          </div>
        )}
      </ToolkitProvider>

      {openInfoAlert && (
        <Snackbar
          open={openInfoAlert}
          autoHideDuration={2000}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleInfoClose} severity="info">
            {infoAlertText}
          </Alert>
        </Snackbar>
      )}
    </div>
  );
};
export default DataTableTransactionEndRecieve;
